module.exports = __webpack_public_path__ + "static/media/30_MichaelWalta_webfinal.ef72f56e.jpg";